module.exports = __webpack_public_path__ + "img/libra-1.df8c2366.png";